// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const SVGSendArrow = props => /*#__PURE__*/_jsx("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  children: /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.368 18.983l-3.217-7.245c-.038-.083-.06-.173-.06-.263-.015-.217.037-.667.39-1.012l2.505-2.498c.292-.292.765-.292 1.057 0 .293.293.293.765 0 1.058l-2.28 2.28 2.663 6.427 5.7-15.847L2.211 7.448l4.027 1.335c.39.127.608.555.473.945-.128.39-.555.607-.945.472l-4.68-1.552s-.045-.015-.068-.03c-.232-.105-.435-.278-.57-.495-.135-.218-.202-.473-.195-.728.008-.255.098-.502.248-.712.15-.21.36-.36.607-.45L18.044.323c.224-.083.472-.09.704-.038.233.053.45.173.623.345.173.173.293.383.345.623.052.232.037.48-.038.705l-5.925 16.935c-.082.24-.24.457-.45.607-.21.15-.457.24-.712.248-.255.007-.51-.06-.727-.195-.218-.135-.39-.338-.496-.57z"
  })
}));
SVGSendArrow.displayName = 'SVGSendArrow';
export default SVGSendArrow;